
    import './styles.scoped.css';
    export default {
  "header": "awsui_header_dgs8z_qsmmj_5",
  "body": "awsui_body_dgs8z_qsmmj_6",
  "footer": "awsui_footer_dgs8z_qsmmj_7"
};
  